"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20HarnessFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_initialAmount",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_tokenName",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "_decimalUnits",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_tokenSymbol",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "failTransferFromAddresses",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "failTransferToAddresses",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "harnessSetBalance",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_fail",
                type: "bool",
            },
        ],
        name: "harnessSetFailTransferFromAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_fail",
                type: "bool",
            },
        ],
        name: "harnessSetFailTransferToAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class ERC20HarnessFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides) {
        return super.deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides || {});
    }
    getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides) {
        return super.getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC20HarnessFactory = ERC20HarnessFactory;
ERC20HarnessFactory.bytecode = _bytecode;
ERC20HarnessFactory.abi = _abi;
//# sourceMappingURL=ERC20HarnessFactory.js.map